import { render, staticRenderFns } from "./DocumentPortalComplete.vue?vue&type=template&id=17b14607&scoped=true&"
import script from "./DocumentPortalComplete.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocumentPortalComplete.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DocumentPortalComplete.vue?vue&type=style&index=0&id=17b14607&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b14607",
  null
  
)

export default component.exports